import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { globalStyles } from './components/cssSnippets';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <style jsx global>{globalStyles}</style>
    <App />
  </React.StrictMode>
);